<template>
  <v-row>
    <v-col md="12">
      <div class="calendar">
        <div class="header">
          <i class="btn-prev" @click="subtractMonth"></i>
          <h4>{{ Meses[monthDate - 1] + " - " + year }}</h4>
          <i class="btn-next" @click="addMonth"></i>
        </div>
        <ul class="weekdays">
          <template v-for="(day, index) in nameDays">
            <li :key="index">{{ day }}</li>
          </template>
        </ul>
        <ul class="dates">
          <template v-for="blank in firstDayOfMonth">
            <li class="blank-day" :key="blank.day">&nbsp;</li>
          </template>
          <template v-for="(date, index) in daysInMonth">
            <li
              @click="setDate(date.day, monthDate, year)"
              :class="{
                'current-day':
                  date.day == today.get('date') &&
                  month == initialMonth &&
                  year == initialYear,
                'disable-day': !allowedDay(
                  year + '-' + monthDate + '-' + date.day
                ),
              }"
              :key="index"
            >
              <span>{{ date.day }}</span>

              <div class="event" v-if="date.eventsNumber > 0">
                <p>{{ date.eventsNumber }} {{ nombreUnidad }}</p>
              </div>
            </li>
          </template>
        </ul>
      </div>
    </v-col>
  </v-row>
</template>

<style scoped>
.calendar {
  text-align: center;
}
.calendar .header {
  position: relative;
  display: block;
}
.calendar h4 {
  text-transform: uppercase;
}
h4 {
  font-size: 2em;
  line-height: 1.25em;
  margin: 0.25em 0;
  display: block;
  font-size: 1.5em;
  margin-block-start: 0.83em;
  margin-block-end: 0.83em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}
.btn-prev {
  left: 6em;
}
.btn-next {
  right: 6em;
}
.btn-prev,
.btn-next {
  border: 2px solid #cbd1d2;
  border-radius: 50%;
  color: #cbd1d2;
  height: 2em;
  font-size: 0.75em;
  line-height: 2em;
  margin: -1em -6em;
  position: absolute;
  top: 50%;
  width: 2em;
}
.calendar .weekdays {
  list-style: none;
  margin: 0;
  padding: 0;
}

.calendar .weekdays li {
  list-style-type: none;
  text-transform: uppercase;
  margin-bottom: 0.5em;
  float: left;
  display: list-item;
  width: 14.28571%;
  border-bottom: 1px solid #0084c0;
}
.calendar .dates {
  list-style: none;
  margin: 0;
  padding: 0;
}
.calendar .dates li {
  list-style-type: none;
  text-transform: uppercase;
  margin-bottom: 0.5em;
  float: left;
  display: list-item;
  width: 14.28571%;
}
.calendar .dates li {
  border-bottom: 1px solid #eee;
  min-height: 3em;
  max-height: 3em;
}
.current-day {
  background: #00addf;
  color: #f9f9f9;
}
.disable-day {
  background: #22262726;
  color: #f9f9f9;
  pointer-events: none;
}
.blank-day {
  color: #f9f9f9;
  pointer-events: none;
}
.dates :hover {
  background: #00addf;
  cursor: pointer;
  color: #f9f9f9;
}
.current-day .event {
  color: #f9f9f9;
}
.event {
  font-size: 8px;
  color: #f2711c;
  max-height: 1em;
}
</style>

<script>
import moment from "moment";

export default {
  name: "simple-vue-calendar",
  components: {},
  props: [
    "value",
    "events",
    "eventsName",
    "right-icon",
    "left-icon",
    "modelMoment",
    "availableDates",
  ],
  data() {
    return {
      today: moment(),
      dateContext: moment(),
      minDate: moment(),
      Meses: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
    };
  },
  methods: {
    allowedDay(a) {
      if (this.availableDates) {
        return this.availableDates.includes(
          moment(a, "YYYY-MM-DD").format("YYYY-MM-DD")
        );
      } else {
        return true;
      }
    },
    setDate(date, month, year) {
      let newDate = date + "-" + month + "-" + year;
      this.today = moment(newDate, "DD-MM-YYYY");
      if (this.modelMoment) {
        this.$emit("input", this.today);
        this.$emit("onSelect", this.today);
      } else {
        this.$emit("input", this.today.format("YYYY-MM-DD"));
        this.$emit("onSelect", this.today.format("YYYY-MM-DD"));
      }
    },
    addMonth() {
      this.dateContext = moment(this.dateContext).add(1, "month");
      this.changeMonth();
    },
    subtractMonth() {
      this.dateContext = moment(this.dateContext).subtract(1, "month");
      this.changeMonth();
    },
    changeMonth() {
      let dateMonth = this.year + "-" + this.monthDate;
      let startOfMonth = moment(dateMonth, "YYYY-MM")
        .startOf("month")
        .format("YYYY-MM-DD");
      let endOfMonth = moment(dateMonth, "YYYY-MM")
        .endOf("month")
        .format("YYYY-MM-DD");
      this.$emit("onChangeMonth", this.monthDate, startOfMonth, endOfMonth);
      this.$emit("updatePicker", startOfMonth);

      //moment.locale('es')
    },
  },
  computed: {
    nameDays() {
      moment.locale("es");
      let weekArray = moment.weekdays();
      let days = [];
      weekArray.forEach((item) => {
        let dayname = item.substring(0, 3);
        days.push(dayname.toUpperCase());
      });
      return days;
    },
    nombreUnidad() {
      let unidad = this.eventsName ? this.eventsName : "Events";
      return unidad;
    },
    year() {
      return this.dateContext.format("Y");
    },
    month() {
      return this.dateContext.format("MMMM");
    },
    monthDate() {
      return this.dateContext.format("MM");
    },
    daysInMonth: function() {
      let days = this.dateContext.daysInMonth();
      let arrayDays = [];
      for (var i = 1; i <= days; i++) {
        let newDate =
          this.year +
          "-" +
          this.monthDate +
          "-" +
          i.toString().padStart(2, "0");
        let totalEvent = 0;
        let Event = [];
        if (this.events) {
          this.events.forEach((element) => {
            if (element.Date == newDate) {
              totalEvent++;
              Event.push(element);
            }
          });
        }

        arrayDays.push({ day: i, eventsNumber: totalEvent, events: Event });
      }
      return arrayDays;
    },
    currentDate: function() {
      return this.dateContext.get("date");
    },
    firstDayOfMonth: function() {
      var firstDay = moment(this.dateContext).subtract(
        this.currentDate - 1,
        "days"
      );
      let arrayDays = [];
      for (var i = 1; i <= firstDay.weekday(); i++) {
        arrayDays.push({ day: i + 100 });
      }
      return arrayDays;
    },
    initialDate: function() {
      return this.today.get("date");
    },
    initialMonth: function() {
      return this.today.format("MMMM");
    },
    initialYear: function() {
      return this.today.format("Y");
    },
  },
  watch: {
    value: function(newValue) {
      if (this.modelMoment) {
        this.today = newValue;
        this.dateContext = newValue;
      } else {
        this.today = moment(newValue, "YYYY-MM-DD");
        this.dateContext = moment(newValue, "YYYY-MM-DD");
      }
      this.$forceUpdate();
    },
  },
  beforeMount: function() {
    if (this.modelMoment) {
      this.today = this.value;
      this.dateContext = this.value;
    } else {
      this.today = moment(this.value, "YYYY-MM-DD");
      this.dateContext = moment(this.value, "YYYY-MM-DD");
    }
    this.$forceUpdate();
  },
  mounted() {
    this.$emit("updatePicker", this.today.format("YYYY-MM-DD"));

    moment.locale("es", {
      week: {
        dow: 7,
      },
    });
  },
};
</script>
